import type { MetadataSEO } from '../../domain/MetadataSEO'

interface GetMetadataSEOArguments {
  [key: string]: any
  seoDescription?: string
  seoTitle?: string
}

export function getMetadataSEO({
  seoDescription: description,
  seoTitle: title,
}: GetMetadataSEOArguments | undefined = {}): MetadataSEO | undefined {
  if (!(description || title)) {
    return undefined
  }

  return {
    description,
    title,
  }
}
